<template>
  <div class="visual-inventory">
    <!-- call {{ call }} -->
    <!-- me: {{ me }} -->

    <h3
      v-if="!comp"
      class="ma-4 text-center text-uppercase"
      color="blue-darken-3"
    >
      {{ isHost ? customerName + " Inventory" : "My Inventory" }}
    </h3>

    <h3 class="text-center" v-else>Visual Inventory</h3>

    <div>
      <div class="ma-2 justify-center">
        <v-call-notifications
          v-if="call"
          :callAccepted="callAccepted"
          :call="call"
          :answerCall="answerCall"
          :key="notifKey"
          :customerName="customerName"
        ></v-call-notifications>
      </div>
      <div class="ma-2 justify-center">
        <v-call-options
          :me="me"
          :callAccepted="callAccepted"
          :callEnded="callEnded"
          :customerName="customerName"
          :leaveCall="leaveCall"
          :sendMail="sendMail"
          :sendSMS="sendSMS"
          :client_id="client_id"
          :callUser="callUser"
          :isHost="isHost"
          :customerEmail="customerEmail"
          :customerPhone="customerPhone"
          :companyId="companyId"
          :company_id="company_id"
          :caller="caller"
          :comp="comp"
        ></v-call-options>
      </div>
      <div class="ma-2 justify-center">
        <video-frame
          ref="myVideo"
          :isUserVideo="false"
          :callAccepted="callAccepted"
          :callEnded="callEnded"
          v-if="stream"
          :stream="stream"
          :isHost="isHost"
          :callerId="callerId"
          :customerName="customerName"
          :customerEmail="customerEmail"
          :caller="caller"
          :key="myVideoKey"
          :comp="comp"
          :uploadVideo="uploadVideo"
        ></video-frame>
      </div>

      <video-frame
        ref="userVideo"
        :isUserVideo="true"
        :callAccepted="callAccepted"
        :callEnded="callEnded"
        :uploadVideo="uploadVideo"
        :stream="userStream"
        :callerId="callerId"
        :isHost="isHost"
        :key="userVideoKey"
        :comp="comp"
      ></video-frame>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { io } from "socket.io-client";
import * as fun from "../plugins/common";
// const io = require("socket.io-client");
export default {
  name: "VisualInventory",
  components: {
    VideoFrame: () => import("../components/VideoFrame.vue"),
    VCallOptions: () => import("../components/CallOptions.vue"),
    VCallNotifications: () => import("../components/CallNotifications.vue"),
  },
  props: {
    comp: Boolean,
    customer: String,
    company: String,
    companyId: String,
    company_id: String,
    email: String,
    customerPhone: String,
    sendMail: Function,
    sendSMS: Function,
    uploadVideo: Function,
    client_id: Number,
  },
  data() {
    return {
      useCamera: false,
      socket: null,
      me: "",
      customerName: "",
      stream: null,
      userStream: null,
      id: null,
      call: null,
      callAccepted: false,
      callEnded: false,
      mycall: null,
      connectionRef: {
        current: null,
      },
      notifKey: 0,
      myVideoKey: 0,
      userVideoKey: 0,
      isHost: false,
      callerId: "",
      Peer: require("simple-peer"),
      customerEmail: "",
      caller: "",
    };
  },
  mounted() {
    var that = this;
    // var socketUrl = window.location.protocol + "//" + window.location.host.replace(":" + window.location.port, "") + ":3030"
    // console.log(socketUrl)
    var socketUrl = "https://server.moverai.com:5000";
    // var socketUrl = this.serverURL;
    this.socket = io(socketUrl);

    if (!this.comp) {
      this.customerEmail = fun.getParameterByName("customerEmail");
      this.customerName = fun.getParameterByName("customerName");
      this.caller = fun.getParameterByName("caller");
    } else {
      this.customerEmail = this.email;
      this.customerName = this.customer;
      this.caller = this.company;
    }

    this.callerId = fun.getParameterByName("callerId");

    if (!this.callerId) {
      this.isHost = true;
    }

    navigator.mediaDevices
      .getUserMedia({
        audio: true,
        video: {
          facingMode: "environment",
        },
      })
      .then((currentStream) => {
        that.stream = currentStream;
        // that.stream.getTracks().forEach((track) => track.stop());
      });
    this.socket.on("me", (id) => {
      that.me = id;
    });

    this.socket.on("calluser", ({ from, name: callerName, signal }) => {
      console.log("socket on calluser");

      this.call = {
        isReceivedCall: true,
        from: from,
        name: this.customerName,
        signal: signal,
      };
      // this.notifKey = !this.notifKey;
    });
  },
  beforeDestroy() {
    if (this.stream) {
      this.stream.getTracks().forEach((track) => track.stop());
    }
  },
  beforeUnmount() {
    if (this.stream) {
      this.stream.getTracks().forEach((track) => track.stop());
    }
  },
  methods: {
    answerCall() {
      var that = this;
      this.callAccepted = true;

      const peer = new this.Peer({
        initiator: false,
        trickle: false,
        stream: this.stream,
      });
      peer.on("signal", (data) => {
        that.socket.emit("answercall", { signal: data, to: this.call.from });
      });
      peer.on("stream", (currentStream) => {
        that.userStream = currentStream;
      });
      peer.signal(this.call.signal);
      this.connectionRef.current = peer;
    },
    callUser(id) {
      console.log(id);
      // this.call = { id: id };

      var that = this;
      const peer = new this.Peer({
        initiator: true,
        trickle: false,
        stream: this.stream,
      });

      console.log(peer);
      peer.on("signal", (data) => {
        that.socket.emit("calluser", {
          userToCall: id,
          signalData: data,
          from: that.me,
          name: that.customerName,
        });
      });
      peer.on("stream", (currentStream) => {
        that.userStream = currentStream;
      });
      this.socket.on("callaccepted", (signal) => {
        that.callAccepted = true;
        peer.signal(signal);
      });
      this.connectionRef.current = peer;
    },
    leaveCall() {
      this.callEnded = true;
      this.connectionRef.current.destroy();
      // this.userVideoKey = !this.userVideoKey;
      // this.myVideoKey = !this.myVideoKey;
      // this.$refs.userVideo.downloadVideo();
      // window.location.reload()
    },
  },
};
</script>

<style lang="css" scoped>
@media only screen and (min-width: 900px) {
  /* .main-wrap {
    height: 70vh;
  } */
  .visual-inventory {
    /* position: fixed;*/
    max-height: 60vh;
    width: 26vw;
    /* overflow-y: auto; */
    overflow-x: hidden;
  }
}
@media only screen and (max-width: 450px) {
  .visual-inventory {
    width: 90vw;
    overflow-x: hidden;
    overflow-y: auto;
  }
}
</style>
